import { TextField, Tooltip, Zoom } from '@material-ui/core'
import React, { FunctionComponent } from 'react'
import { useTranslate } from 'react-admin'
import { validationErrorToString } from 'src/adminPanel/screens/inputs/validators'
import { IInputProps } from 'src/types'

const StringInput: FunctionComponent<IInputProps<string>> = ({
  property,
  name,
  onChange,
  onBlur,
  value,
  classes,
  invalid,
  touched = false,
  error,
  ...props
}: IInputProps<string>) => {
  const translate = useTranslate()

  const handleChange: React.ChangeEventHandler<
    HTMLTextAreaElement | HTMLInputElement
  > = ({ target: { value } }) => {
    onChange(value)
  }

  return (
    <Tooltip
      TransitionComponent={Zoom}
      placement='right'
      title={property.description ?? ''}
      arrow
    >
      <TextField
        fullWidth
        className={typeof classes === 'string' ? classes : undefined}
        variant={property?.multiline === true ? 'outlined' : undefined}
        onChange={handleChange}
        onBlur={onBlur}
        placeholder={props.placeholder ?? property.displayedName ?? name}
        label={property.displayedName ?? name}
        value={value ?? property.defaultValue ?? ''}
        helperText={validationErrorToString(translate)(error)}
        error={touched && invalid}
        disabled={property?.readOnly}
        multiline={property.multiline}
        maxRows={25}
        InputLabelProps={props.InputLabelProps}
      />
    </Tooltip>
  )
}

export default StringInput
